import styles from "../../../styles/Participant-Employment.module.css"
import { engagementChannels } from "../../../components/Appointments/utils"
import {
  getDuration,
  getStartAndEndTime,
  groupBy,
  groupTable,
} from "../Utils/Utils"
import ViewHeader from "../Utils/ViewHeader"
const TransitionPlanView = ({
  viewMode,
  loading,
  closeViewMode,
  transitionPlan,
}) => {
  const transitionPlanDic = [
    {
      label: "Engagement date",
      value: transitionPlan?.engagementDate,
      type: "date",
      group: 1,
    },
    {
      label: "Engagement channel",
      value: engagementChannels[transitionPlan?.engagementChannel],
      type: "string",
      group: 1,
    },
    {
      label: "Engagement duration",
      value: getDuration(transitionPlan?.startTime, transitionPlan?.endTime),
      type: "string",
      group: 1,
    },
    {
      label: "Start/End time",
      value: getStartAndEndTime(
        transitionPlan?.startTime,
        transitionPlan?.endTime
      ),
      type: "string",
      group: 1,
    },
    {
      label: "What are your future plans?",
      value: transitionPlan?.futurePlans,
      type: "html",
      group: 2,
    },
    {
      label: "What are your short-term goals?",
      value: transitionPlan?.shortTermGoals,
      type: "html",
      group: 3,
    },
    {
      label: "What are your long term goals?",
      value: transitionPlan?.longTermGoals,
      type: "html",
      group: 4,
    },
    {
      label: "Are you currently employed?",
      value: transitionPlan?.currentyEmployed === 1 ? "Yes" : "No",
      type: "string",
      group: 5,
    },
    {
      label: "How would you like to be contacted in the future?",
      value: transitionPlan?.engagementChannelStr,
      type: "string",
      group: 5,
    },
    {
      label:
        "How often would you like someone to check-in with you about your employment and who should check-in with you?",
      value: transitionPlan?.checkIn,
      type: "html",
      group: 6,
    },
    {
      label:
        "When would be a good time to ask you about returning to IPS for help with employment or education and Who should contact you?",
      value: transitionPlan?.ips,
      type: "html",
      group: 7,
    },
    {
      label:
        "When would be a good time to ask you about returning to IPS for help with employment or education and Who should contact you?",
      value: transitionPlan?.toolsStrategies,
      type: "html",
      group: 8,
    },
    {
      label:
        "How would you know if you started to feel dissatisfied with your job or that you were having other problems?",
      value: transitionPlan?.dissatisfied,
      type: "html",
      group: 9,
    },
    {
      label: "What are some reasons to reconnect to IPS in the future?",
      value: transitionPlan?.reconnectIPS,
      type: "html",
      group: 10,
    },
    {
      label: "Contact name",
      value: transitionPlan?.benefitsContactName,
      type: "string",
      group: "benefits",
    },
    {
      label: "Contact email",
      value: transitionPlan?.benefitsContactEmail,
      type: "string",
      group: "benefits",
    },
    {
      label: "Contact phone",
      value: transitionPlan?.benefitsContactPhone,
      type: "string",
      group: "benefits",
    },
  ]
  const contactDic = transitionPlan?.contacts
    ?.map((contact, index) => {
      return [
        {
          label: "Name",
          value: contact.name,
          type: "string",
          group: index,
        },
        {
          label: "Email",
          value: contact.email,
          type: "string",
          group: index,
        },
        {
          label: "Phone",
          value: contact.supportPhone,
          type: "string",
          group: index,
        },
        {
          label: "Contact Type",
          value: contact.contactType,
          type: "string",
          group: index,
        },
        {
          label: "Types of support preferred",
          value: contact.typesOfSupport,
          type: "string",
          group: index,
        },
        {
          label: "Schedule a meeting with this support contact?",
          value: contact.schedule ? "Yes" : "No",
          type: "string",
          group: index,
        },
      ]
    })
    .flat()

  const basicInfo1 = groupBy(
    transitionPlanDic.filter((t) => t.group !== "benefits"),
    "group"
  )

  const contactInfo = groupBy(contactDic, "group")
  const benefitsInfo = groupBy(
    transitionPlanDic.filter((t) => t.group === "benefits"),
    "group"
  )
  return (
    <>
      <div className={styles.rounded_wrapper}>
        {viewMode && (
          <ViewHeader
            closeViewMode={closeViewMode}
            title={"Transition Plan"}
            viewMode={viewMode}
          />
        )}

        {groupTable(basicInfo1)}
        {contactInfo &&
          groupTable(contactInfo, "Who can help with your career goals?")}
        {benefitsInfo && groupTable(benefitsInfo, "Benefits planner")}
      </div>
    </>
  )
}
export default TransitionPlanView
